import type { DiwassCredentials } from '@/types/nest/diwass'
import type { UUID } from 'crypto'
import { axiosClient } from '@/utils/axios-client'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDiwassStore = defineStore('diwassStore', () => {
  /*
   * Fetch: {@link fetchCredentials}
   */
  const credentials = ref<DiwassCredentials | null>(null)

  /*
   * Data: {@link diwassCredentials}
   */
  async function fetchCredentials(customerId: UUID) {
    const response = await axiosClient.request<DiwassCredentials>({
      url: '/diwass/credentials',
      method: 'GET',
      params: { id: customerId },
    })

    credentials.value = response.data
  }

  async function createCredentials(payload: DiwassCredentials, customerId: UUID) {
    await axiosClient.request({
      url: '/diwass/credentials',
      method: 'POST',
      data: { ...payload, customerId },
    })
  }

  async function updateCredentials(payload: Omit<Partial<DiwassCredentials>, 'id'> & { id: UUID }) {
    await axiosClient.request({
      url: '/diwass/credentials',
      method: 'PUT',
      data: { ...payload },
    })
  }

  async function deleteCredentials(payload: DiwassCredentials) {
    await axiosClient.request({
      url: `/diwass/credentials/${payload.id}`,
      method: 'DELETE',
    })
  }

  return {
    credentials,
    fetchCredentials,
    createCredentials,
    updateCredentials,
    deleteCredentials,
  }
})
